module.exports = __webpack_public_path__ + "img/qr-code.7689e4c8.png";